import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "./api";

const AuthContext = createContext({
  user: null,
  loading: true,
  refresh: () => Promise.resolve(),
  logout: () => Promise.resolve(),
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await apiClient.get("/auth/me", { withCredentials: true });
      setUser(r.data);
      return r.data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await apiClient.post("/auth/logout", null, { withCredentials: true });
    } catch {
      /* ignore */
    }
    setUser(null);
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from Emergent OAuth, the session_id is in the
    // URL hash and AuthCallback owns the exchange — skip /auth/me here to
    // avoid a doomed 401 race.
    if (
      typeof window !== "undefined" &&
      window.location.hash?.includes("session_id=")
    ) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH — we derive the redirect from window.location.origin.
 */
export function startLogin(returnTo) {
  const dest = returnTo || "/dashboard";
  const redirectUrl = window.location.origin + dest;
  window.location.href =
    "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
}
